import { TeamsUFOExperience } from '@atlaskit/teams-client/ufo';
import { ExperiencePerformanceTypes, ExperienceTypes, untilAll } from '@atlaskit/ufo';

export const renderTeamMemberRemoveDialogSubExp: TeamsUFOExperience = new TeamsUFOExperience(
	'render-team-member-remove-dialog',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		platform: { component: 'people' },
	},
);

export const renderTeamAgentRemoveDialogSubExp: TeamsUFOExperience = new TeamsUFOExperience(
	'render-team-agent-remove-dialog',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		platform: { component: 'people' },
	},
);

export const removeMemberFromTeamSubExp: TeamsUFOExperience = new TeamsUFOExperience(
	'remove-member-from-team-action',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		platform: { component: 'people' },
	},
);

export const removeAgentFromTeamSubExp: TeamsUFOExperience = new TeamsUFOExperience(
	'remove-agent-from-team-action',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		platform: { component: 'people' },
	},
);

const removeMemberFromTeamSubExperiences: TeamsUFOExperience[] = [
	renderTeamMemberRemoveDialogSubExp,
	removeMemberFromTeamSubExp,
];

export const removeMemberFromTeamExp: TeamsUFOExperience = new TeamsUFOExperience(
	'remove-a-member-from-team',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.Custom,
		platform: { component: 'people' },
		until: untilAll(
			removeMemberFromTeamSubExperiences.map((experience) => ({
				experience,
			})),
		),
	},
);

export const removeAgentFromTeamExp: TeamsUFOExperience = new TeamsUFOExperience(
	'remove-a-agent-from-team',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.Custom,
		platform: { component: 'people' },
		until: untilAll(
			removeMemberFromTeamSubExperiences.map((experience) => ({
				experience,
			})),
		),
	},
);

export const teamSettingsOverallExp: TeamsUFOExperience = new TeamsUFOExperience(
	'membership-control-change',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		platform: { component: 'people' },
	},
);

export const teamSettingsHandleRequestsExp: TeamsUFOExperience = new TeamsUFOExperience(
	'membership-control-change-handle-requests',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		platform: { component: 'people' },
	},
);

export const teamSettingsChangeTeamTypeExp: TeamsUFOExperience = new TeamsUFOExperience(
	'membership-control-change-change-team-type',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		platform: { component: 'people' },
	},
);

export const renderTeamMemberInviteDialogSubExp: TeamsUFOExperience = new TeamsUFOExperience(
	'render-team-member-invite-dialog',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		platform: { component: 'people' },
	},
);

export const addNewMembertoTeamSubExp: TeamsUFOExperience = new TeamsUFOExperience(
	'add-new-member-to-team-action',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		platform: { component: 'people' },
	},
);

export const associateNewAgentToTeamSubExp: TeamsUFOExperience = new TeamsUFOExperience(
	'link-agent-to-team-action',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		platform: { component: 'people' },
	},
);

export const inviteMembersToTeamExperience: TeamsUFOExperience = new TeamsUFOExperience(
	'invite-members-to-team',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.Custom,
		platform: { component: 'people' },
	},
);
